module.exports = __webpack_public_path__ + "bb4.no1.7ae1a5dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bb4.no1.jpg
// module id = mLPh
// module chunks = 0